import styled from "@emotion/styled";
import { Tooltip } from "@mui/material";
import type { ReactNode } from "react";

import { FONT_WEIGHT_SEMI_BOLD } from "../../../utilities";

const Container = styled.div`
  display: flex;
  gap: 18px;

  &[disabled] {
    opacity: 0.4;
  }
`;

const Description = styled.span`
  color: ${({ theme }) => theme.generalTextIcon};

  font-size: 14px;
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  line-height: 18px;
`;

export const Help = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 18px;
  height: 18px;

  color: ${({ theme }) => theme.primaryStrong};

  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  font-size: 1em;

  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.primaryStrong};

  cursor: help;
`;

type Props = Pick<HTMLInputElement, "disabled"> & {
  description: ReactNode;
  tooltip: ReactNode;
};

export const FieldContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 100%;

  --field-min-width: 120px;
`;

export const FieldDescription = ({ description, tooltip, ...rest }: Props) => (
  <Container {...rest}>
    <Description>{description}</Description>
    {tooltip && (
      <Tooltip title={tooltip}>
        <Help>?</Help>
      </Tooltip>
    )}
  </Container>
);
